"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.broadcastUpdate = exports.broadcastSuccess = exports.broadcastSoftDeletedList = exports.broadcastSoftDeleteRestore = exports.broadcastSoftDelete = exports.broadcastSelect = exports.broadcastList = exports.broadcastFetch = exports.broadcastError = exports.broadcastDelete = exports.broadcastBulkSoftDelete = exports.broadcastBulkRestore = exports.broadcastBulkHardDelete = exports.broadcastAdd = void 0;
var _broadcast = require("./broadcast.constant");
// @flow

// common success
var broadcastSuccess = function broadcastSuccess(actionType, data) {
  return {
    type: _broadcast.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.broadcastSuccess = broadcastSuccess;
var broadcastError = function broadcastError(actionType, error) {
  return {
    type: _broadcast.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.broadcastError = broadcastError;
var broadcastFetch = function broadcastFetch(data) {
  return {
    type: _broadcast.actionTypes.FETCH,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.broadcastFetch = broadcastFetch;
var broadcastList = function broadcastList(data) {
  return {
    type: _broadcast.actionTypes.LIST,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
exports.broadcastList = broadcastList;
var broadcastDelete = function broadcastDelete(data) {
  return {
    type: _broadcast.actionTypes.DELETE,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.broadcastDelete = broadcastDelete;
var broadcastAdd = function broadcastAdd(data) {
  return {
    type: _broadcast.actionTypes.ADD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.broadcastAdd = broadcastAdd;
var broadcastUpdate = function broadcastUpdate(data) {
  return {
    type: _broadcast.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * select
 * @param payload
 * @returns api response
 * @description this function used to select data.
 */
exports.broadcastUpdate = broadcastUpdate;
var broadcastSelect = function broadcastSelect(data) {
  return {
    type: _broadcast.actionTypes.SELECT,
    payload: data
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete.
 */
exports.broadcastSelect = broadcastSelect;
var broadcastSoftDelete = function broadcastSoftDelete(data) {
  return {
    type: _broadcast.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft delete restore.
 */
exports.broadcastSoftDelete = broadcastSoftDelete;
var broadcastSoftDeleteRestore = function broadcastSoftDeleteRestore(data) {
  return {
    type: _broadcast.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft deleted list.
 */
exports.broadcastSoftDeleteRestore = broadcastSoftDeleteRestore;
var broadcastSoftDeletedList = function broadcastSoftDeletedList(data) {
  return {
    type: _broadcast.actionTypes.SOFT_DELETED_LIST,
    payload: data
  };
};

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete.
 */
exports.broadcastSoftDeletedList = broadcastSoftDeletedList;
var broadcastBulkSoftDelete = function broadcastBulkSoftDelete(data) {
  return {
    type: _broadcast.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore.
 */
exports.broadcastBulkSoftDelete = broadcastBulkSoftDelete;
var broadcastBulkRestore = function broadcastBulkRestore(data) {
  return {
    type: _broadcast.actionTypes.BULK_RESTORE,
    payload: data
  };
};

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard delete.
 */
exports.broadcastBulkRestore = broadcastBulkRestore;
var broadcastBulkHardDelete = function broadcastBulkHardDelete(data) {
  return {
    type: _broadcast.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};
exports.broadcastBulkHardDelete = broadcastBulkHardDelete;